import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wage",
  "use": "icon-wage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-wage\"><defs><style type=\"text/css\"></style></defs><path d=\"M448 960H64V64h896v192h-128V192h-128l-64 64H384L320 192H192v640h256v128z m230.4-448L576 409.6 665.6 320 768 422.4 870.4 320 960 409.6 857.6 512H960v128h-128v64h128v128h-128v128h-128v-128H576v-128h128v-64H576V512h102.4z\" p-id=\"2045\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol